import BN from 'bn.js'
import Hash from './hash'


export const isAddress = key => /^0x[0-9a-fA-F]{40}$/.test(key)
export const isTx = key => /^0x[0-9a-fA-F]{64}$/.test(key)
export const isHeight = key => {
    const num = parseInt(key)
    return key === num.toString() && num >= 0
}

export default {
    sortJsonByDate(obj) {
        var endValue, item, key, keyArray, keyArray2, o, _i, _len;
        endValue = {};
        keyArray = [];
        keyArray2 = [];
        for (key in obj) {
            o = {};
            o[key] = obj[key];
            keyArray.push(key);
        }
        keyArray2 = keyArray.sort();
        for (_i = 0, _len = keyArray2.length; _i < _len; _i++) {
            item = keyArray2[_i];
            endValue[item] = obj[item];
        }
        return endValue;
    },
}

const tSec = 1000
const tMin = tSec * 60
const tHr = tMin * 60
const tDay = tHr * 24
const tYear = tDay * 365

export const getDuration = time => {
    if (time < tMin) {
        const secs = parseInt(time / tSec)
        return `${secs} sec${secs > 1 ? 's' : ''} ago`
    } else if (time < tHr) {
        const secs = parseInt(time % tMin / tSec)
        const mins = parseInt(time / tMin)
        const secsStr = secs ? `${secs} sec${secs > 1 ? 's' : ''} ` : ''
        return `${mins} min${mins > 1 ? 's' : ''} ${secsStr}ago`
    } else if (time < tDay) {
        const mins = parseInt(time % tHr / tMin)
        const hrs = parseInt(time / tHr)
        const minsStr = mins ? `${mins} min${mins > 1 ? 's' : ''} ` : ''
        return `${hrs} hr${hrs > 1 ? 's' : ''} ${minsStr}ago`
    } else if (time < tYear) {
        const hrs = parseInt(time % tDay / tHr)
        const days = parseInt(time / tDay)
        const hrsStr = hrs ? `${hrs} hr${hrs > 1 ? 's' : ''} ` : ''
        return `${days} day${days > 1 ? 's' : ''} ${hrsStr}ago`
    } else {
        const years = parseInt(time / tYear)
        return `> ${years} year${years > 1 ? 's' : ''}`
    }
}

export const updateAge = data => {
    const now = new Date()
    if (!data) {
        return ''
    } else {
        const time = new Date(data)
        return getDuration(now - time)
    }
}

export const parseBalance = (input, decimals) => {
    const decs = decimals || 18
    let balance
    if (input.substr(0, 2) === '0x') {
        balance = new BN(input.slice(2), 16)
    } else {
        balance = new BN(input, 10)
    }
    const balanceStr = balance.toString().padStart(decs + 1, '0')
    const i = balanceStr.slice(0, -decs)
    const d = Array.prototype.reduce.call(balanceStr.slice(-decs), (res, n, i) => res + (i % 3 ? n : ',' + n), '')
    return { i, d }
}

export const getSortAddress = data => {
        if (data) {
            return data.substr(0, 10) + '...' + data.substr(data.length-5)
        }
}


export const isNumber = data => {
    // var reg = /^[0-9]+.?[0-9]*$/;
    var reg = /^[0-9]*[1-9][0-9]*$/;
    if (reg.test(data)) {
        return true;
    }
    return false;
}


export const parseBigBalance = (input, decimals) => {
    const decs = decimals || 18
    let balance
    if (input.substr(0, 2) === '0x') {
        balance = new BN(input.slice(2), 16)
    } else {
        balance = new BN(input, 10)
    }
    const balanceStr = balance.toString().padStart(decs + 1, '0')
    const iLength = balanceStr.length - decs
    const i = Array.prototype.reduce.call(balanceStr.slice(0, -decs), (res, n, i) => res + ((iLength - i) % 3 || !i  ? n : ',' + n), '')
    const d = balanceStr.substr(-decs, 4)
    return { i, d }
}

export const parseBigInter = (input) => {
    let balance
    if (input.substr(0, 2) === '0x') {
        balance = new BN(input.slice(2), 16)
    } else {
        balance = new BN(input, 10)
    }
    return balance
}


//地址转换大小写
export const updateAddress = address => {
    const adrList = []
    address = address.toLowerCase().replace(/^0x/i,'')
    const addressHash = Hash.keccak256(address).replace(/^0x/i,'')

    for (var i = 0; i < 40; i++ ) {
        if (parseInt(addressHash[i], 16) > 7) {
            adrList.push(address[i].toUpperCase())
        } else {
            adrList.push(address[i].toLowerCase())
        }
    }
    return '0x' + adrList.join('')
}

